import React from 'react';
import SVGIcon, { SVGIconName } from 'containers/SVGicon';
import Tippy from '@tippyjs/react';
import { ButtonAsIcon } from 'css/components/Modules/Buttons';

type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

const getIconSize = (size: IconSize) => {
  let width, height;

  switch (size) {
    case 'xs':
      width = 9;
      height = 9;
      break;
    case 'sm':
      width = 12;
      height = 12;
      break;

    case 'md':
      width = 14;
      height = 14;
      break;

    case 'lg':
      width = 16;
      height = 16;
      break;

    case 'xl':
      width = 18;
      height = 18;
      break;

    case 'xxl':
      width = 24;
      height = 24;
      break;

    default:
      width = 16;
      height = 16;
  }

  return { height, width };
};

interface TooltipInfoTextProps {
  content: string | React.ReactNode;
  placement?: string | any;
  allowHTML?: boolean;
  iconSize?: IconSize;
  icon?: SVGIconName;
  iconClass?: string;
}

export const TooltipInfoText = ({
  content,
  placement = 'auto',
  allowHTML,
  iconSize = 'lg',
  icon = 'infoIcon',
  iconClass
}: TooltipInfoTextProps) => {
  const { width, height } = getIconSize(iconSize);

  return (
    <Tippy
      content={content}
      placement={placement}
      interactive={true}
      appendTo={() => document.body}
      allowHTML={allowHTML || false}
    >
      <ButtonAsIcon className='p-0' type='button'>
        <SVGIcon
          name={icon}
          width={`${width}`}
          height={`${height}`}
          className={`${iconClass} ms-1`}
        />
      </ButtonAsIcon>
    </Tippy>
  );
};
